// extracted by mini-css-extract-plugin
export var editButton = "detailsEvent-module--edit-button--c3228";
export var evenement = "detailsEvent-module--evenement--36971";
export var eventContent = "detailsEvent-module--event-content--5c8f2";
export var eventDate = "detailsEvent-module--event-date--3113e";
export var eventDateFrom = "detailsEvent-module--event-date-from--0e275";
export var eventDateTo = "detailsEvent-module--event-date-to--d2619";
export var eventFooter = "detailsEvent-module--event-footer--f1f48";
export var eventFooterBack = "detailsEvent-module--event-footer-back--537bf";
export var eventImg = "detailsEvent-module--event-img--a58b6";
export var eventPlace = "detailsEvent-module--event-place--fa566";
export var eventPlaceIcon = "detailsEvent-module--event-place-icon--f4fcf";
export var eventPlaceTitle = "detailsEvent-module--event-place-title--87e8f";
export var eventTaxo = "detailsEvent-module--event-taxo--37327";
export var eventTitle = "detailsEvent-module--event-title--bc24f";
export var eventsItemRecurrence = "detailsEvent-module--events-item-recurrence--f93d9";
export var pageEvent = "detailsEvent-module--page-event--b2eee";
export var pageEventAdditionalInfos = "detailsEvent-module--page-event-additional-infos--8b7d3";